import type { StaticFile } from "@/types/staticFiles"
import { defineStore } from "pinia"
import { StaticFiles } from "@/services"

export const StaticFilesModule = defineStore("staticFiles", {
  state: () => ({
    appIcons: [] as StaticFile[]
  }),
  actions: {
    async getAppIcons() {
      const req = await StaticFiles.getAppIcons()
      this.appIcons = req.data.data
    }
  }
})
